module.exports = __webpack_public_path__ + "static/media/21ECLAC17.32e78841.jpg";